import { motion } from "framer-motion";

// These placeholders will be replaced with real approved client stories & photos once submitted.
// Kept intentionally short, generic, and clearly marked as sample copy where relevant.
const stories = [
  {
    dog: "Working Shepherd",
    city: "Chicago, IL",
    text: "The transformation didn't just fix our dog — it fixed the way we lead the household. That's the difference.",
    img: "https://images.unsplash.com/photo-1568572933382-74d440642117?w=1000&q=80&auto=format&fit=crop",
  },
  {
    dog: "Rescue Doberman",
    city: "Nairobi, KE",
    text: "Reactive on-leash for two years. Off-leash reliable in ten days at Wolfkeeper Bootcamp.",
    img: "https://images.unsplash.com/photo-1568393691622-c7ba131d63b4?w=1000&q=80&auto=format&fit=crop",
  },
  {
    dog: "Belgian Malinois",
    city: "Los Angeles, CA",
    text: "Toriano treats the human like the primary student. That's why the training actually holds when we get home.",
    img: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=1000&q=80&auto=format&fit=crop",
  },
];

export default function Testimonials() {
  return (
    <section className="section bg-ink-2" data-testid="testimonials">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-10">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">Training Transformations</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.2rem,5.5vw,5.5rem)] leading-[0.95] tracking-[-0.02em]">
              Real dogs.<br/><span className="italic gold-foil">Real households.</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {stories.map((s, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.05 * i }}
              className="rounded-3xl overflow-hidden bg-ink border border-hair"
              data-testid={`testimonial-${i}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={s.img} alt={s.dog} className="w-full h-full object-cover"/>
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent"/>
                <div className="absolute bottom-3 left-3">
                  <div className="text-hair text-gold">{s.dog}</div>
                  <div className="text-xs text-bone/70">{s.city}</div>
                </div>
              </div>
              <div className="p-6">
                <p className="font-editorial italic text-bone/85 text-lg leading-snug">"{s.text}"</p>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="text-hair text-bone/40 mt-6">Full portfolio of approved client transformations available upon request.</div>
      </div>
    </section>
  );
}
